import ArrayUtils from "../../utils/arraysUtils";

const TIPO_ORDEN_CUSTOM = 1;

class OrdenListaObjetosConId {
  constructor(tipo, idsOrdenCustom) {
    this._tipo = tipo;
    this._ids = tipo === TIPO_ORDEN_CUSTOM ? idsOrdenCustom : null;
  }

  equals(orden) {
    return (
      orden.tipo === this.tipo && ArrayUtils.equalsContents(orden.ids, this.ids)
    );
  }

  get tipo() {
    return this._tipo;
  }

  get ids() {
    return this._ids;
  }
}

export { OrdenListaObjetosConId as default, TIPO_ORDEN_CUSTOM };
